import { ApolloQueryResult } from 'apollo-client';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    FETCH_COUNTERS_METRIKA_COUNTER_EDITOR,
    fetchCountersMetrikaCounterEditor,
    FetchCountersMetrikaCounterEditorAction,
    OPEN_METRIKA_COUNTER_EDITOR,
    OpenMetrikaCounterEditorAction,
    setMetrikaUnAvailableFlagForMetrikaCounterEditor,
    updateCountersMetrikaCounterEditor
} from '../../actions/metrikaCounterEditor';
import { mapMetrikaCountersFromApiFormat } from '../../mappers/common/common';
import { EpicDeps } from '../../service/StoreFactory';
import { ClientMetrikaCountersQuery } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

const openChooserMetrikaCounterEditorEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(OPEN_METRIKA_COUNTER_EDITOR),
        filter(() => !store$.value.metrikaCounterEditor.counters),
        map((action: OpenMetrikaCounterEditorAction) => {
            return fetchCountersMetrikaCounterEditor();
        })
    );
};

const fetchCountersEpicMetrikaCounterEditorEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_COUNTERS_METRIKA_COUNTER_EDITOR),
        mergeMap(
            (
                action: FetchCountersMetrikaCounterEditorAction
            ): Observable<Action> => {
                const state = store$.value;
                const { login } = state.commonData;

                return from(
                    deps.commonDataProvider.fetchClientMetrikaCounters(login)
                ).pipe(
                    mergeMap(
                        (
                            response: ApolloQueryResult<
                                ClientMetrikaCountersQuery
                            >
                        ): Observable<Action> => {
                            if (response.data) {
                                const {
                                    isMetrikaAvailable,
                                    counters
                                } = response.data.client.metrikaCounters;

                                if (isMetrikaAvailable) {
                                    return of(
                                        updateCountersMetrikaCounterEditor(
                                            mapMetrikaCountersFromApiFormat(
                                                counters
                                            )
                                        )
                                    );
                                } else {
                                    throw Error();
                                }
                            }

                            throw Error();
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(
                                setMetrikaUnAvailableFlagForMetrikaCounterEditor(
                                    false
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

export const metrikaCounterEditorEpic = combineEpics(
    openChooserMetrikaCounterEditorEpic,
    fetchCountersEpicMetrikaCounterEditorEpic
);
